export default {
  container: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 100001,
    overflowY: "scroll",
    textAlign: "center",
    color: "var(--color-black)",
    background: "var(--color-white)",
  },

  outer: {
    position: "relative",
    top: "50%",
    display: "inline-block",
    width: "calc(1.5 * var(--rhythm))",
    height: "calc(1.5 * var(--rhythm))",
    border: "4px solid var(--color-primary)",
    animation: "loader 2s infinite ease",
  },

  inner: {
    display: "inline-block",
    width: "100%",
    verticalAlign: "top",
    backgroundColor: "var(--color-primary)",
    animation: "loader-inner 2s infinite ease-in",
  },
};
